import axiosInstance from './axios'

/**
 * @function
 * @param {string} endpoint
 * @param {string} token
 * @param {"userService" | "contractManagement" | "bffService"} instance
 */
export const fetcher = async (endpoint, token, instance = 'bffService') => {
  const res = await axiosInstance[instance].get(endpoint, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })

  return res.data
}
